import React from 'react'
import { AppContainer } from 'react-hot-loader'
import { render } from 'react-dom'
import configStore from './common/configStore'
import routeConfig from './common/routeConfig'
import Root from './Root'
import './styles/index.less'
import '@asofix/bumper/dist/tokens.css'
import '@asofix/bumper/dist/bumper.css'


const MAX_AGE_STORE_RETRIEVAL = 900000 // 15 min
const localStorageStore = localStorage.getItem('asofix-redux-store')
const localStorageStoreTimeStamp = JSON.parse(localStorage.getItem('asofix-redux-store-timestamp'))

const getInitialStoreState = () => {
  if (!localStorageStore || Date.now() - localStorageStoreTimeStamp >= MAX_AGE_STORE_RETRIEVAL) {
    return undefined
  }

  try {
    const state = JSON.parse(localStorageStore)
    // Tras F5 no reabrir el modal de llamada
    if (state?.leads?.whatsapp) {
      state.leads.whatsapp.show_calling_modal = false
    }
    return state
  } catch (_) {
    return undefined
  }
}

const hydratedState = getInitialStoreState()
const store = hydratedState ? configStore(hydratedState) : configStore()

function renderApp(app) {
  render(
    <AppContainer>
      <React.Fragment>
        {app}
      </React.Fragment>
    </AppContainer>,
    document.getElementById('root'),
  )
}

renderApp(<Root store={store} routeConfig={routeConfig} />)

// Hot Module Replacement API
/* istanbul ignore if  */
if (module.hot) {
  module.hot.accept('./common/routeConfig', () => {
    const nextRouteConfig = require('./common/routeConfig').default // eslint-disable-line
    renderApp(<Root store={store} routeConfig={nextRouteConfig} />)
  })
  module.hot.accept('./Root', () => {
    renderApp(<Root store={store} routeConfig={routeConfig} />)
  })
}